import {
  CheckmarkCircle,
  CircleMoins,
  InfoFull,
  Sms,
  Warning,
} from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';
import { toast, ToastOptions } from 'react-toastify';

import styles from './ToastContainer.module.scss';

export const defaultToast = (label: string, opts?: ToastOptions): string | number => {
  return toast(
    <div className={styles.toastContent}>
      <Sms className={styles.icon} />
      <p className={styles.text}>{label}</p>
    </div>,
    {
      className: styles.defaultToastContainer,
      bodyClassName: styles.defaultBody,
      ...opts,
    }
  );
};

export const errorToast = (label: string, opts?: ToastOptions): string | number => {
  return toast(
    <div className={styles.toastContent}>
      <CircleMoins className={styles.icon} />
      <p className={styles.text}>{label}</p>
    </div>,
    {
      className: classnames(styles.defaultToastContainer, styles.errorToastContainer),
      bodyClassName: styles.defaultBody,
      ...opts,
    }
  );
};

export const successToast = (label: string, opts?: ToastOptions): string | number => {
  return toast(
    <div className={styles.toastContent}>
      <CheckmarkCircle className={styles.icon} />
      <p className={styles.text}>{label}</p>
    </div>,
    {
      className: classnames(styles.defaultToastContainer, styles.successToastContainer),
      bodyClassName: styles.defaultBody,
      ...opts,
    }
  );
};

export const warningToast = (label: string, opts?: ToastOptions): string | number => {
  return toast(
    <div className={styles.toastContent}>
      <Warning className={styles.icon} />
      <p className={styles.text}>{label}</p>
    </div>,
    {
      className: classnames(styles.defaultToastContainer, styles.warningToastContainer),
      bodyClassName: styles.defaultBody,
      ...opts,
    }
  );
};

export const infoToast = (label: string, opts?: ToastOptions): string | number => {
  return toast(
    <div className={styles.toastContent}>
      <InfoFull className={styles.icon} />
      <p className={styles.text}>{label}</p>
    </div>,
    {
      className: classnames(styles.defaultToastContainer, styles.infoToastContainer),
      bodyClassName: styles.defaultBody,
      ...opts,
    }
  );
};
